import { clsx } from 'clsx';
import styles from './size.module.css';
import { SizeProps } from './size.props';

export const Size = ({ type, value, label, options, className, ...props }: SizeProps) => {
	if (type === 'height') {
		return (
			<div className={clsx(styles.heightWrapper, className)} {...props}>
				<div className={styles.heightArrow}>
					<div className={styles.topArrow} />
					<div className={styles.heightLine} />
				</div>
				<div className={styles.labelWrapper}>
					<p className={styles.labelTitle}>{value}</p>
					{label && <p className={styles.labelText}>{label}</p>}
				</div>
				<div className={styles.heightArrow}>
					<div className={styles.heightLine} />
					<div className={styles.bottomArrow} />
				</div>
			</div>
		);
	}

	if (type === 'width') {
		return (
			<div className={clsx(styles.widthWrapper, className)} {...props}>
				<div className={styles.widthArrow}>
					<div className={styles.leftArrow} />
					<div className={styles.widthLine} />
				</div>
				<div className={styles.labelWrapper}>
					<p className={styles.labelTitle}>{value}</p>
					{label && <p className={styles.labelText}>{label}</p>}
				</div>
				<div className={styles.widthArrow}>
					<div className={styles.widthLine} />
					<div className={styles.rightArrow} />
				</div>
			</div>
		);
	}

	if (type === 'rotate') {
		return (
			<div className={clsx(styles.rotateWrapper, className)} {...props}>
				<div className={styles.lineWrapper} style={{ rotate: `${options.rotate}deg` }}>
					<div className={styles.topArrow} />
					<div className={styles.heightLine} />
					<div className={styles.bottomArrow} />
				</div>
				<div
					className={clsx(
						styles.labelWrapper,
						styles.rotateLabel,
						options.labelClassName,
					)}
				>
					<p className={styles.labelTitle}>{value}</p>
					{label && <p className={styles.labelText}>{label}</p>}
				</div>
			</div>
		);
	}

	return null;
};
